import React, { useEffect } from 'react';
import { useWidget } from 'components/Widget/useWidget';
import IntegrationWidget from 'components/widgets/components/IntegrationWidget';
import ninjaApi from 'store/redux/apis';
import { useWidgetDate } from 'store/redux/states/dates/dates.hooks';
import CampaignSpentActionButton from 'modules/network-accounts/components/IntegrationCampaignSpent/component/CampaignSpentActionButton';

const IntegrationData = ({ widget_key, height, data }) => {
  const [getIntegrationsReports, { data: shopify = [], isLoading, isFetching }] =
    ninjaApi.useLazyIntegrationsReportsQuery();
  const { filters, chartConfig } = useWidget();
  const { date_from, date_to } = useWidgetDate(widget_key);

  useEffect(() => {
    const params = {
      integration: data?.defaultFilter?.integration_type,
      load_chart: chartConfig?.load_chart,
      date_from: date_from,
      date_to: date_to,
      ...filters,
    };

    if (chartConfig?.load_chart) {
      params.group_by = 'date';
    }

    if (params?.date_from) {
      getIntegrationsReports(params).unwrap();
    }
  }, [filters, chartConfig?.load_chart, data]);

  return (
    <IntegrationWidget
      height={height}
      totals={shopify.totals}
      loading={isLoading || isFetching}
      data={shopify}
      integration={data?.defaultFilter?.integration_type}
      widget_key={widget_key}
      exctraAction={
        data?.defaultFilter?.integration_type === 'shopify' && (
          <CampaignSpentActionButton
            id={filters?.integration_ids}
            integration_type={filters?.integration_type}
            size={0.7}
          />
        )
      }
    />
  );
};

export default IntegrationData;
